/* ============================================================
   Brands by Category — bm-brand-category
   Category nav: active-pill on click + scroll-spy highlighting.
   ============================================================ */
(function () {
  function init(root) {
    if (root.dataset.bmbcInit === "1") return;
    root.dataset.bmbcInit = "1";

    var pills = Array.prototype.slice.call(root.querySelectorAll("[data-cat-target]"));
    var sections = Array.prototype.slice.call(root.querySelectorAll("[data-cat-section]"));
    if (!pills.length) return;

    function setActive(id) {
      pills.forEach(function (p) {
        p.classList.toggle("is-active", p.dataset.catTarget === id);
      });
    }

    // Click: set active immediately (anchor href handles the smooth scroll via CSS scroll-margin).
    pills.forEach(function (pill) {
      pill.addEventListener("click", function () { setActive(pill.dataset.catTarget); });
    });

    // Scroll-spy: highlight the pill for the section currently in view.
    if ("IntersectionObserver" in window && sections.length) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) setActive(entry.target.id);
        });
      }, { rootMargin: "-100px 0px -70% 0px" });
      sections.forEach(function (s) { observer.observe(s); });
    }
  }

  function boot() {
    document.querySelectorAll("[data-bmbc]").forEach(init);
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
  document.addEventListener("shopify:section:load", function (e) {
    var root = e.target.querySelector("[data-bmbc]");
    if (root) init(root);
  });
})();